define('controllers/schedule',[
    'underscore',
    'controllers/base/controller',
    'views/pages/schedule',
    'models/pages/schedule',
    'lib/utils'
], function(
    _,
    Controller,
    SchedulePageView,
    SchedulePageModel,
    utils
) {
    'use strict';

    var ScheduleController = Controller.extend({
        show: function(params, o, a) {

            var date = new Date(params.date || a.query.date);
            if (_.isNaN(date.valueOf())) {
                date = new Date();
            }

            var model = new SchedulePageModel({
                loadCenter: utils.truncTime(date).getTime()
            }, {
                parse: true
            });

            this.view = new SchedulePageView({
                model: model
            });

            model.load(true);
        }
    });

    return ScheduleController;
});

